import { format } from 'date-fns';

import type { ObservableRequest } from '@swf/core/hooks/useRequest';

import type { OcrData } from './Incode/incode_types';

interface Response {
  token: string;
  uniqueId?: string;
  onboardingUrl?: string;
  [key: string]: unknown;
}

export const fetchOnboardingUrl = (request: ObservableRequest) =>
  request<Response>({
    service: `/api/v1-preview/account/aristotle/token`,
    method: 'GET',
    http: true
  });

export const adaptDobAcrossTimezones = (d: Date): Date => {
  if (d.getTimezoneOffset() > 0) {
    d.setDate(d.getDate() + 1);
  }
  return d;
};

const formatDOB = (data: OcrData) => {
  let formattedDob;
  try {
    if (data.birthDate) {
      const userDOB = new Date(data.birthDate);
      const adaptedDob = adaptDobAcrossTimezones(userDOB);
      formattedDob = format(adaptedDob, 'yyyy-LL-dd');
    }
  } catch (e) {
    return e;
  }
  return formattedDob;
};

export const buildIncodePayload = (data: OcrData, userDOB?: Date | null) => {
  const postalCode = data.addressFields?.postalCode || data.checkedAddressBean?.postalCode;
  const postalCodeFormat = postalCode?.length === 5;
  const hasAddressFields =
    (data.address || data.checkedAddress) &&
    postalCodeFormat &&
    data.checkedAddressBean?.city &&
    data.checkedAddressBean?.state;
  const formattedDob = formatDOB(data);

  const payload = hasAddressFields
    ? {
        firstName: data.name.givenName,
        lastName: data.name.paternalLastName,
        streetAddress: data.address || data.checkedAddress,
        city: data.checkedAddressBean?.city,
        state: data.checkedAddressBean?.state,
        zip: postalCode,
        dob: formattedDob,
        gender: data.gender,
        fetchAccount: true
      }
    : {
        firstName: data.name.givenName,
        lastName: data.name.paternalLastName,
        dob: formattedDob,
        gender: data.gender,
        fetchAccount: true
      };

  if (userDOB) {
    delete payload.dob;
  }
  return payload;
};
